import {
    FormControl,
    InputLabel,
    Select,
    OutlinedInput,
    MenuItem,
    Checkbox,
    ListItemText,
    CircularProgress,
    FormHelperText,
    ListSubheader,
    Paper,
    Box,
} from "@mui/material"

import { useState, forwardRef, useEffect } from "react";

const CustomPaper = forwardRef(({ children, header, footer, ...other }, ref) => {
    return (
      <Paper ref={ref} {...other}>
        {header}
        {children}
        {footer}
      </Paper>
    );
});

const GroupedSelectMultiple = ({
    label="",
    selected,
    error,
    list,
    isLoading,
    onChange,
    theme,
    listHeader,
    listFooter,
    onStateChange,
    disabled = false,
    paperMaxWidth,
    required,
    dataTestId = {
        inputId: null,
        errorId: null
    }
}) => {

    const [open, setOpen] = useState(false);

    useEffect(() => {
        onStateChange?.(open);
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return (
        <FormControl fullWidth sx={{ ...theme.typography.customAutocomplete }} error={!!error} required={required}>
            <InputLabel id='label'>{label}</InputLabel>
            {isLoading && 
                <CircularProgress color="inherit" size={20} style={{position: 'absolute', zIndex: 999, top: '20px', right: '40px'}} /> 
            }
            <Select
                multiple
                labelId="label"
                value={selected}
                onChange={onChange}
                input={<OutlinedInput />}
                disabled={disabled}
                inputProps={{ "data-testid": dataTestId?.inputId }}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={{
                    PaperProps: {
                      component: CustomPaper,
                      sx: {
                        ...paperMaxWidth && { maxWidth: paperMaxWidth },
                      },
                      header: <Box position="sticky" top={0} bgcolor="background.paper" zIndex={100}>{listHeader}</Box>,
                      footer: (
                        <Box
                          sx={{ position: "sticky", bottom: 0, bgcolor: "white" }}
                        >
                          {listFooter?.(() => setOpen(false))}
                        </Box>
                      ),
                    },
                }}
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
            >
                {list.map((item, i) => (
                    !item.id 
                    ? <ListSubheader key={i} sx={{textTransform: "uppercase"}}>{item.label}</ListSubheader>
                    : <MenuItem key={item.id} value={item.label}>
                        <Checkbox checked={selected.indexOf(item.label) > -1} />
                        {
                            item.sharedBy 
                            ? <ListItemText 
                                primary={item.label} 
                                sx={{display: "flex" }} 
                                secondary={item.sharedBy} 
                                secondaryTypographyProps={{fontSize: 12, color: "text", ml: 1.5}} 
                            /> 
                            : <ListItemText primary={item.label} />
                        }
                    </MenuItem>
                ))}
            </Select>
            {error !== null && (
                <FormHelperText data-testid={dataTestId.errorId}>{error}</FormHelperText>
            )}
        </FormControl>
    )
}

export default GroupedSelectMultiple;